import * as types from "./types";
import {
    getProjectByIdAxios,
    getProjectListAxios,
    postProjectAxios,
    putProjectAxios,
    deteteProjectAxios,
    getProjectTasksAxios,
    postProjectTaskAxios,
    putProjectTaskAxios,
    deteteProjectTaskAxios,
    getProjectAssigneesAxios,
    getProjectMilestoneAxios,
    postProjectMilestoneAxios,
    deteteProjectMilestoneAxios,
    putProjectMilestoneAxios,
    updateProjectTaskAxios,
    getProjectSubTasksAxios,
    postProjectSubTaskAxios,
    putProjectSubTaskAxios,
    deteteProjectSubTaskAxios,
    updateProjectSubTaskAxios,
} from "./services";

//#region Project

export async function getProjectListAction({ commit }) {
    commit(types.LOADING_PROJECT, true);
    try {
        const { data } = await getProjectListAxios();
        commit(types.GET_PROJECT_LIST, data.result.data);
    }
    catch (e) {
        console.log(e);
        throw e;
    }
    finally {

        commit(types.LOADING_PROJECT, false);
    }
}

export async function removeProjectAction({ commit }, payload) {
    commit(types.LOADING_PROJECT, true);
    try {
        await deteteProjectAxios(payload);
        commit(types.REMOVE_PROJECT, payload);
    }
    catch (e) {
        console.log(e);
        throw e;
    }
    finally {

        commit(types.LOADING_PROJECT, false);
    }
}

export async function addProjectAction({ commit }, payload) {
    commit(types.LOADING_PROJECT, true);
    try {
        await postProjectAxios(payload);
        commit(types.ADD_PROJECT, payload);
    }
    catch (e) {
        console.log(e);
        throw e;
    }
    finally {

        commit(types.LOADING_PROJECT, false);
    }
}

export async function updateProjectAction({ commit }, payload) {
    commit(types.LOADING_PROJECT, true);
    try {
        await putProjectAxios(payload);
        commit(types.UPDATE_PROJECT, payload);
    }
    catch (e) {
        console.log(e);
        throw e;
    }
    finally {
        commit(types.LOADING_PROJECT, false);
    }
}

export async function getProjectByIdAction({ commit }, id) {
    commit(types.LOADING_PROJECT, true);
    try {       
        console.log("🚀 ~ getProjectByIdAction ~ id:", id)
        const { data } = await getProjectByIdAxios(id);
        commit(types.GET_PROJECT_ID, data.result);
        return data.result;

    }
    catch (e) {
        console.log(e);
        throw e;
    }
    finally {

        commit(types.LOADING_PROJECT, false);
    }
}

//#endregion

//#region Tasks

export async function getProjectTasksAction({ commit }, {id, milestoneId}) {
    console.log("🚀 ~ getProjectTasksAction ~ id:", id)
    commit(types.LOADING_PROJECT, true);
    try {
        const { data } = await getProjectTasksAxios(id, milestoneId);
        commit(types.GET_PROJECT_TASK, data.result.data);
    }
    catch (e) {
        console.log(e);
        throw e;
    }
    finally {

        commit(types.LOADING_PROJECT, false);
    }
}

export async function addProjectTaskAction({ commit }, payload) {
    commit(types.LOADING_PROJECT, true);
    try {
        await postProjectTaskAxios(payload);
        commit(types.ADD_PROJECT_TASK, payload);
    }
    catch (e) {
        console.log(e);
        throw e;
    }
    finally {
        commit(types.LOADING_PROJECT, false);
    }
}

export async function removeProjectTaskAction({ commit }, payload) {
    commit(types.LOADING_PROJECT, true);
    try {
        await deteteProjectTaskAxios(payload);
        commit(types.REMOVE_PROJECT_TASK, payload);
    }
    catch (e) {
        console.log(e);
        throw e;
    }
    finally {
        commit(types.LOADING_PROJECT, false);
    }
}

export async function updateProjectTaskAction({ commit }, payload) {
    commit(types.LOADING_PROJECT, true);
    try {
        await putProjectTaskAxios(payload);
        commit(types.UPDATE_PROJECT_TASK, payload);
    }
    catch (e) {
        console.log(e);
        throw e;
    }
    finally {
        commit(types.LOADING_PROJECT, false);
    }
}

export async function updateProjectTaskStatusAction({ commit }, payload) {
    commit(types.LOADING_PROJECT, true);
    try {
        await updateProjectTaskAxios(payload);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_PROJECT, false);
    }
}

//#endregion

//#region Sub Tasks

export async function getProjectSubTasksAction({ commit }, {projectid, taskid}) {
    commit(types.LOADING_PROJECT, true);
    try {
        const { data } = await getProjectSubTasksAxios(projectid, taskid);
        commit(types.GET_PROJECT_SUBTASK, data.result.data);
    }
    catch (e) {
        console.log(e);
        throw e;
    }
    finally {

        commit(types.LOADING_PROJECT, false);
    }
}

export async function addProjectSubTaskAction({ commit }, payload) {
    commit(types.LOADING_PROJECT, true);
    try {
        const { data } = await postProjectSubTaskAxios(payload);
        commit(types.ADD_PROJECT_SUBTASK, payload);
        return data;
    }
    catch (e) {
        console.log(e);
        throw e;
    }
    finally {
        commit(types.LOADING_PROJECT, false);
    }
}

export async function removeProjectSubTaskAction({ commit }, payload) {
    commit(types.LOADING_PROJECT, true);
    try {
        await deteteProjectSubTaskAxios(payload);
        commit(types.REMOVE_PROJECT_SUBTASK, payload);
    }
    catch (e) {
        console.log(e);
        throw e;
    }
    finally {
        commit(types.LOADING_PROJECT, false);
    }
}

export async function updateProjectSubTaskAction({ commit }, payload) {
    commit(types.LOADING_PROJECT, true);
    try {
        const { data } = await putProjectSubTaskAxios(payload);
        commit(types.UPDATE_PROJECT_SUBTASK, payload);
        return data;
    }
    catch (e) {
        console.log(e);
        throw e;
    }
    finally {
        commit(types.LOADING_PROJECT, false);
    }
}

export async function updateProjectSubTaskStatusAction({ commit }, payload) {
    commit(types.LOADING_PROJECT, true);
    try {
        await updateProjectSubTaskAxios(payload);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_PROJECT, false);
    }
}

//#endregion

//#region Milestones

export async function getProjectMilestoneAction({ commit }, id) {
    commit(types.LOADING_PROJECT, true);
    try {
        const { data } = await getProjectMilestoneAxios(id);
        commit(types.GET_PROJECT_MILESTONE, data.result.data);
    }
    catch (e) {
        console.log(e);
        throw e;
    }
    finally {
        commit(types.LOADING_PROJECT, false);
    }
}

export async function addProjectMilestoneAction({ commit }, payload) {
    commit(types.LOADING_PROJECT, true);
    try {
        await postProjectMilestoneAxios(payload);
        commit(types.ADD_PROJECT_MILESTONE, payload);
    }
    catch (e) {
        console.log(e);
        throw e;
    }
    finally {
        commit(types.LOADING_PROJECT, false);
    }
}

export async function updateProjectMilestoneAction({ commit }, payload) {
    commit(types.LOADING_PROJECT, true);
    try {
        await putProjectMilestoneAxios(payload);
        commit(types.UPDATE_PROJECT_MILESTONE, payload);
    }
    catch (e) {
        console.log(e);
        throw e;
    }
    finally {
        commit(types.LOADING_PROJECT, false);
    }
}

export async function removeProjectMilestoneAction({ commit }, id) {
    commit(types.LOADING_PROJECT, true);
    try {
        await deteteProjectMilestoneAxios(id);
        commit(types.REMOVE_PROJECT_MILESTONE, id);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_PROJECT, false);
    }
}

//#endregion

export async function getProjectAssigneesAction({ commit }) {
    commit(types.LOADING_PROJECT, true);
    try {
        const { data } = await getProjectAssigneesAxios();
        commit(types.GET_PROJECT_ASSIGNEES, data.result);
    }
    catch (e) {
        console.log(e);
        throw e;
    }
    finally {
        commit(types.LOADING_PROJECT, false);
    }
}